import React from 'react';

type IconProps = {
    colorBody?: string;
    colorHead?: string;
    colorStar?: string;
    width?: number;
    height?: number;
};

const IconUserCircle: React.FC<IconProps> = ({
    colorBody = '#505050',
    colorHead = '#505050',
    colorStar = '#505050',
    width = 17,
    height = 17,
}) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_9314_12602)">
                <path
                    d="M9.99984 0.109375C4.54395 0.109375 0.102539 4.5477 0.102539 10.0067C0.102539 15.4038 4.48211 19.8854 9.97512 19.8978H9.99984C12.7432 19.8978 15.2176 18.7813 17.0053 16.9874C18.793 15.1935 19.8972 12.7192 19.8972 10.0067C19.8972 4.54769 15.4588 0.109375 9.99984 0.109375ZM11.6577 10.4799C12.6814 9.90152 13.3773 8.80355 13.3773 7.54477C13.3773 5.68281 11.8618 4.17039 9.99984 4.17039C8.14102 4.17039 6.62547 5.68281 6.62547 7.54477C6.62547 8.80355 7.32137 9.90152 8.34512 10.4799C5.67902 11.0582 3.49543 13.0006 2.64797 15.6512C1.44176 14.0862 0.721094 12.1284 0.721094 10.0067C0.721094 4.88789 4.88418 0.727969 9.99984 0.727969C15.1186 0.727969 19.2786 4.88793 19.2786 10.0067C19.2786 12.1284 18.5611 14.0862 17.3548 15.6513C16.5073 13.0037 14.3237 11.0582 11.6577 10.4799Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_9314_12602">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconUserCircle;
